import { createApp } from 'vue'
import Vant from 'vant'
import 'vant/lib/index.css';
import App from './App.vue'
import router from './router'
import wx from 'weixin-js-sdk'
const formatDate = function(date, fmt) {
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    let o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
    }
    for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
            let str = o[k] + ''
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : (('00' + str).substr(str.length)))
        }
    }
    return fmt
}
window.$formatDate = formatDate

const app = createApp(App);
app.use(Vant).use(router).use(wx).mount('#app')
